export const STATUS = {
  AVAILABLE: 'available',
  UNAVAILABLE: 'unavailable',
  BOOKED: 'booked',
  COMPLETE: 'complete',
};

export const MIN_SESSION_DURATION_MINUTES = 5;
